module.exports = __webpack_public_path__ + "static/media/investment.b890a069.png";